import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Grid, Typography } from "@sumprio/ui";
import "./SomethingWentWrong.scss";

export default function SomethingWentWrong() {
  const history = useHistory();

  return (
    <div className="something-went-wrong">
      <Grid display="flex" flexDirection="column" alignItems="center" gap="lg">
        <div className="something-went-wrong__icon" aria-hidden>
          <svg
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="something-went-wrong__cloud"
          >
            <path
              d="M95 55c0-16-13-29-29-29-10 0-19 5-24 12-5-3-11-5-17-5-14 0-25 11-25 25 0 2 0 4 1 6-12 2-21 12-21 24 0 13 11 24 24 24h69c11 0 20-9 20-20 0-10-7-18-17-20 1-3 2-6 2-9z"
              fill="currentColor"
            />
            <path
              d="M60 35v50M60 45l-12 12M60 45l12 12M60 65l-8 8M60 65l8 8"
              stroke="var(--color-brand-600, #2563eb)"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <Typography variant="heading" headingSize="md" headingWeight="medium">
          So Sorry, Something Went Wrong
        </Typography>
        <Typography variant="body" bodySize="sm" bodyWeight="regular" color="secondary">
          we couldn&apos;t find what you were looking for...
        </Typography>
        <Button variant="brand-default" size="xs" onClick={() => history.goBack()}>
          Return To Previous Page
        </Button>
      </Grid>
    </div>
  );
}
